import React from 'react';
import NumberFormat from 'react-number-format';

import { setApp, getApp} from '../../index';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import { regex } from '../../Utils/ValidationPatterns';

class NumberField extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: '' };
    }

    valChange(event) {
        var newVal = event.target.value;
        this.setState({ value: newVal });
        var fieldName = this.props.name;
        this.setState({ value: newVal });       
        setApp(fieldName, newVal);

        // Validation for Applicant and Co-Applicant has to be over 18 years old
        if(fieldName === 'dob' || fieldName === 'ca_dob' || fieldName === 'as_dob') {
            var fieldDate = new Date(getApp(fieldName));

            function twoDigits(val) {
                if(val > 9) {
                    return val;
                }else{
                    return "0" + val;
                }
            }

            var fieldDatePre =  fieldDate.getFullYear() + "" + twoDigits(fieldDate.getMonth() + 1) + "" + twoDigits(fieldDate.getDate());
            var fieldDateTest = fieldDatePre - 0;
            var curDate = new Date();
            var curDateTest =  curDate.getFullYear() + "" + twoDigits(curDate.getMonth() + 1) + "" + twoDigits(curDate.getDate());
            var age = curDateTest - fieldDateTest;
            var blockKey;

            if(fieldName === 'dob') {
                blockKey = 'blockAge';
            }else if(fieldName === 'ca_dob') {
                blockKey = 'caBlockAge';
            }

            if(age >= 180000) {
                setApp(blockKey, false);
            }else{
                setApp(blockKey, true);
            }

            if(fieldName === "as_dob" && age <= 10000){
                setApp("auBlockAge", true);
            }else{
                setApp("auBlockAge", false);
            }
        }

    }

    // blurEncrypt(event) {
    //     var appEncName = this.props.encName;
    //     if(this.props.encrypt === true) {
    //         encrypt(appEncName, event.target.value);
    //     }
    // }

    clearZero(event) {
        if(event.target.value === "0") {
            event.target.value = "";
        }
    }

    render() {
        var existingValue = getApp(this.props.name);
        let exVal;

        if(existingValue !== "") {
            exVal = existingValue;
        }else{
            exVal = "";
        }

        return (
            <div className="loanApp-form-field loanApp-text-field loanApp-text-field-morph">
                <NumberFormat
                    type={this.props.type ? this.props.type : "text"}
                    name={this.props.name} 
                    required={this.props.required} 
                    className="loanApp-form-control"
                    onChange={this.valChange.bind(this)}
                    onFocus={this.clearZero.bind(this)}
                    // onBlur={this.blurEncrypt.bind(this)}
                    value={exVal}
                    max={this.props.max ? this.props.maxLength : "30"}
                    min={this.props.min ? this.props.minLength : "2"}
                    format={this.props.format}
                    mask={this.props.mask ? this.props.mask : ''}
                    thousandSeparator={true}
                    prefix={this.props.prefix ? this.props.prefix : ''}
                    pattern={this.props.pattern ? this.props.pattern : regex}
                    title={this.props.guidelines ? this.props.guidelines : "Please check this field and try again."}
                />
                <label htmlFor={this.props.name}>{this.props.label}</label>
                <InvalidFeedback feedback={this.props.feedback ? this.props.feedback : "invalid"} />
            </div>
        )
    }
}

export default NumberField;